module.exports = __webpack_public_path__ + "fe2714a635c26023bf481e0fa6cf5246.svg";